import { PimResource } from "./pim-resource.js";
import * as PIM from "../pim-vocabulary.js";
/**
 * Represents a class. On the PIM level the properties are not pointed to
 * from the class. Instead the properties specify an owner class and the
 * associations ends points to classes.
 */
export class PimClass extends PimResource {
    static TYPE = PIM.CLASS;
    pimExtends = [];
    pimIsCodelist = false;
    pimCodelistUrl = [];
    pimRegex = null;
    pimExample = null;
    pimObjectExample = null;
    constructor(iri = null) {
        super(iri);
        this.types.push(PimClass.TYPE);
    }
    static is(resource) {
        return resource?.types.includes(PimClass.TYPE);
    }
}
//# sourceMappingURL=pim-class.js.map